import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-acesso-negado-generico',
  templateUrl: './acesso-negado-generico.component.html',
  styleUrls: ['./acesso-negado-generico.component.css']
})
export class AcessoNegadoGenericoComponent implements OnInit {

  public mensagemErro: string;
  public numeroErro: number;

  constructor(private messageService: MessageService) { }

 
  
  ngOnInit() {

      this.messageService.currentErrorMessage.subscribe(messageError => {
      if (messageError) {
        this.numeroErro = messageError[0]
        this.mensagemErro = messageError[1]
      }
    });

  }

 
  


}
